<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        Career
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- Job openings -->
  <div class="md:px-10 max-w-screen-xl mx-auto relative z-10 mt-4 px-6 lg:-mt-20">
    <!-- Job Opening section -->
    <div class="relative py-5 text-start strategic-card">
      <h3 class="text-blue font-bold text-2xl inline-block relative">
        Job Opening
      </h3>
      <div
        class="absolute top-8 left-20 transform translate-x-4 -translate-y-6 bg-yellow text-black px-3 py-1 rounded-lg shadow-lg rotate-12"
      >
        Your Idea Starts Here
      </div>
    </div>

     <!-- Job search and listing -->
     <div
      class="flex flex-col lg:flex-row items-center justify-between px-5 pt-10"
    >
      <p class="font-bold">Open Positions:</p>
      <div class="relative">
        <input
          type="search"
          placeholder="Search for jobs"
          class="py-1 pl-8 pr-4 rounded-full border border-gray-400 text-sm"
        />
        <i
          class="fa fa-search absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400"
        ></i>
      </div>
    </div>

    <!-- Job Card -->
    <div class="mt-5 px-5 py-14">
      <div
        class="bg-white shadow-md rounded-lg p-4 py-2 flex items-center gap-4 border border-gray-200"
      >
        <div class="py-3 flex items-center gap-10">
          <img src="../assets/images/job-opening.png" alt="Job" class="h-28" />
          <div>
            <h3 class="text-lg font-bold">IT Support</h3>
            <router-link to="/career/job-requirement">
              <button class="bg-yellow text-black px-4 py-2 rounded-md mt-2">
                Apply now
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Join Mshel Homes section (Moves Up Correctly) -->
  <div
    class="md:px-10 max-w-screen-2xl mx-auto relative z-10 mt-4 px-6"
  >
    <!-- Why Work with Mshel Homes Limited? -->
    <div class="bg-white rounded-lg p-8 mt-10 shadow-lg">
      <h3 class="text-blue-600 font-extrabold text-3xl">
        Why Work with Mshel Homes Limited?
      </h3>
      <p class="mt-4 text-gray-700 leading-relaxed">
        At Mshel Homes, we are committed to fostering a supportive, inclusive,
        and rewarding work environment where employees thrive, grow, and feel
        valued. Here’s why you should join us:
      </p>

      <div class="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Healthy Workplace</strong> – A positive and supportive
            environment that promotes well-being.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Competitive Salary</strong> – Attractive remuneration that
            reflects your expertise and contributions.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Diversity & Inclusion</strong> – A culture that embraces and
            supports all employees equally.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Career Growth & Development</strong> – Training, mentorship,
            and professional advancement opportunities.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Employee Recognition & Rewards</strong> – Performance-based
            incentives and appreciation programs.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Health Maintenance Organization (HMO) Coverage</strong> –
            Access to quality healthcare services.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Employee Benefits</strong> – Pension contributions, NSITF,
            and Group Life Assurance.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Bereavement Support</strong> – Financial support during
            family loss.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Childbirth Support</strong> – Paid maternity/paternity leave
            and financial assistance.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>13th Month Salary</strong> – Extra financial appreciation
            for your hard work.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Training Support</strong> – Sponsored learning and
            professional certifications.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Team Bonding & Social Events</strong> – Retreats, company
            events, and team activities.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Paid Time Off & Leave Benefits</strong> – Generous annual
            and sick leave.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Performance Bonuses</strong> – Additional incentives for
            exceeding targets.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Mshel Cooperative</strong> – Investment opportunities with
            other employees.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Diversified Income</strong> – Earn commissions from property
            marketing.
          </p>
        </div>

        <div class="flex items-start">
          <span class="text-green-500 text-xl mr-3">✅</span>
          <p class="text-gray-700">
            <strong>Retirement Benefits</strong> – Structured retirement
            planning for long-term security.
          </p>
        </div>
      </div>

      <p class="mt-6 text-gray-700 font-medium">
        At Mshel Homes Limited, we don’t just build homes—we build careers,
        opportunities, and a family of thriving professionals.
      </p>
    </div>

    <!-- Life at Mshel Homes section -->
    <div class="grid md:grid-cols-2 gap-6 items-center py-5">
      <div class="bg-white rounded-lg p-6">
        <h3 class="text-blue font-bold text-2xl">Life at Mshel homes</h3>
        <p class="mt-4 text-gray-600">
          In our bustling real estate company, every day is a whirlwind of
          energy, ambition, and opportunity. Jonathan, a young intern fresh out
          of college, quickly learns that life in real estate is about more than
          just buying and selling properties—it's about building relationships,
          solving problems, and helping people find their dream homes.
        </p>
      </div>
      <div>
        <img
          src="../assets/images/hr.png"
          alt="Life at Mshel"
          class="w-full rounded-lg"
        />
      </div>
    </div>

    <!-- Join Mshel Great Minds section -->
    <div class="grid md:grid-cols-2 gap-6 items-center py-5">
      <div class="mt-5">
        <img
          src="../assets/images/job-career.png"
          alt="Job Career"
          class="w-full rounded-lg"
        />
      </div>
      <div class="bg-white rounded-lg p-6">
        <h3 class="text-blue font-bold text-2xl">
          Join Mshel <br />Great Minds
        </h3>
        <p class="mt-4 text-gray-600">
          Join us today to build a world of greatness in real estate making a
          difference and owning a piece of the world.
        </p>
        <div class="mt-4">
          <input
            type="text"
            placeholder="email"
            class="w-full p-2 rounded-full border border-gray-300"
          />
          <button class="w-full bg-yellow text-black p-2 rounded-full mt-2">
            Subscribe
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}

.fade-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}
.fade-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
